import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import SelectComponent from "../../../components/Tenant/SelectComponent/SelectComponent";
import { useFetchAllSchemeMutation } from "../../../features/tenant/scheme/schemeApi";
import { useBulkTransferMutation } from "../../../features/tenant/WalletTransfer/walletTransferApi";
import toast from "react-hot-toast";

const WalletTransfer = () => {
    const tenant_id = JSON.parse(sessionStorage.getItem("vendorData")).tenant_id;
    const token = sessionStorage.getItem("access_token");

    const [fetchAllScheme, { data: schemeData, isLoading: schemeIsLoading }] = useFetchAllSchemeMutation();
    const [bulkTransfer, { isLoading: transferLoading }] = useBulkTransferMutation();

    const [wallets, setWallets] = useState([]);
    const [fromWallet, setFromWallet] = useState(null);
    const [toWallet, setToWallet] = useState(null);

    useEffect(() => {
        fetchAllScheme({
            token,
            tenant_id,
            body: { name: "", limit: 1000, offset: 0 }
        });
    }, [token, tenant_id]);

    useEffect(() => {
        if (schemeData && schemeData.body) {
            const schemes = schemeData.body.data.map(scheme => ({
                id: scheme.id,
                name: scheme.name,
                scheme_end: scheme.scheme_end
            }));
            const allWallets = [
                { id: "main", name: "Main Wallet" },
                ...schemes
            ];
            setWallets(allWallets);
        }
    }, [schemeData]);

    console.log(wallets);

    const handleTransfer = async () => {
        if (!fromWallet || !toWallet) {
            toast.error("Please select both source and destination wallets");
            return;
        }

        if (fromWallet.id === toWallet.id) {
            toast.error("Source and destination wallets must be different");
            return;
        }

        // Check if schemes have ended
        const isSchemeActive = (wallet) => {
            if (wallet.id === "main") return false;
            if (!wallet.scheme_end) return false;
            return new Date(wallet.scheme_end) > new Date();
        };

        if (isSchemeActive(fromWallet)) {
            toast.error(`Transfer restricted: Scheme "${fromWallet.name}" is still active and has not ended yet.`);
            return;
        }

        if (isSchemeActive(toWallet)) {
            toast.error(`Transfer restricted: Scheme "${toWallet.name}" is still active and has not ended yet.`);
            return;
        }

        try {
            const response = await bulkTransfer({
                token,
                tenant_id,
                body: {
                    from_wallet: String(fromWallet.id),
                    to_wallet: String(toWallet.id)
                }
            }).unwrap();

            if (response.success || response.status === 200) {
                toast.success(response.message || "Bulk transfer initiated successfully");
            } else {
                toast.error(response.message || "Transfer failed");
            }
        } catch (error) {
            toast.error(error?.data?.message || "Something went wrong during transfer");
        }
    };

    return (
        <div className="flex w-full bg-gray-200 h-full justify-center">
            <div className="w-full">
                <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                    Wallet Points Transfer
                    <LinksComponent />
                </div>

                <div className="p-6">
                    <div className="bg-white shadow-lg rounded-2xl p-8 mx-auto">
                        <div className="mb-8">
                            {/* <h2 className="text-2xl font-bold text-gray-800 mb-2">Bulk Points Migration</h2> */}
                            <p className="text-gray-800 text-base">
                                Transfer points for <b>all users</b> between the selected wallets.
                                This operation is irreversible and will migrate all point metrics.
                            </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10">
                            <div className="space-y-2">
                                <SelectComponent
                                    title="From Wallet (Source)"
                                    selected={fromWallet}
                                    setSelected={setFromWallet}
                                    dataArr={wallets}
                                    required={true}
                                />
                                {fromWallet && (
                                    <p className="text-[10px] text-blue-600 font-medium px-1">
                                        Source: {fromWallet.name}
                                    </p>
                                )}
                            </div>

                            <div className="space-y-2">
                                <SelectComponent
                                    title="To Wallet (Destination)"
                                    selected={toWallet}
                                    setSelected={setToWallet}
                                    dataArr={wallets}
                                    required={true}
                                />
                                {toWallet && (
                                    <p className="text-[10px] text-green-600 font-medium px-1">
                                        Destination: {toWallet.name}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="flex flex-col items-center w-20">
                            <button
                                onClick={handleTransfer}
                                disabled={transferLoading || schemeIsLoading}
                                className={`w-full py-3 rounded-xl text-white font-bold text-lg transition-all shadow-md active:scale-[0.98] ${transferLoading || schemeIsLoading
                                    ? "bg-gray-400 cursor-not-allowed"
                                    : "bg-blue-600 hover:bg-blue-700 shadow-blue-200"
                                    }`}
                            >
                                {transferLoading ? (
                                    <span className="flex items-center justify-center gap-2">
                                        <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                        Processing Transfer...
                                    </span>
                                ) : (
                                    "Initiate Bulk Transfer"
                                )}
                            </button>
                            <p className="mt-4 text-xs text-gray-400 italic">
                                * This process may take a few moments to complete for all records.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WalletTransfer;
